import { WarningIcon } from "vega-icons";

type TooltipErrorContentProps = {
  error: string;
};

export const TooltipErrorContent = ({ error }: TooltipErrorContentProps) => (
  <span className="flex items-center text-xs font-normal text-text/negative">
    <WarningIcon aria-hidden="true" className="w-5 h-5 mr-2 shrink-0" />
    {error}
  </span>
);
